module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "note-editor"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localNote.title),
      expression: "localNote.title"
    }],
    staticClass: "title-editor form-control",
    attrs: {
      "type": "text",
      "placeholder": "Add title here..."
    },
    domProps: {
      "value": (_vm.localNote.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.localNote.title = $event.target.value
      }, _vm.updateNote]
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localNote.content),
      expression: "localNote.content"
    }],
    staticClass: "content-editor form-control",
    attrs: {
      "placeholder": "Add content here..."
    },
    domProps: {
      "value": (_vm.localNote.content)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.localNote.content = $event.target.value
      }, _vm.updateNote]
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b21897e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 69
// module chunks = 1